import { create } from 'zustand';
import dayjs from 'dayjs';
import { fetchUserOrderStatus } from 'lib/apis';
import { ORDER_STATE } from 'lib/constants/order';
import { isOrderTimeOverYear } from 'lib/utils/util';
import toast from 'lib/utils/toast';

interface UserOrderInfo {
  orderTime?: string;
  orderState?: ORDER_STATE;
  orderMobile?: string;
  pId?: string;
  channelCode?: string;
  operatorType?: number;
  isOverYear?: boolean;
  pType?: number;
  isSubscriber?: boolean; // 当前是否为订购用户，包括订购成功、退订中、退订成功
}

type Store = {
  userOrderInfo: UserOrderInfo;
  queryUserOrderInfo: (params: string) => void;
};

export const useUserOrderStore = create<Store>((set) => ({
  userOrderInfo: {},
  queryUserOrderInfo: async (channelCode: string) => {
    toast.loading();
    const res = await fetchUserOrderStatus({
      channelCodes: [channelCode],
    });
    toast.close();
    if (res?.code !== 0) return;
    const { data } = res;
    const { orderInfo: orderList } = data;
    const sortOrderList = orderList.sort(
      (a: UserOrderInfo, b: UserOrderInfo) => dayjs(b.orderTime).valueOf() - dayjs(a.orderTime).valueOf(),
    );
    const orderInfo = sortOrderList[0] || {};
    const isOverYear = isOrderTimeOverYear(orderInfo?.orderTime);
    const isSubscriber = [ORDER_STATE.ORDER_SUCCESS, ORDER_STATE.CANCELING, ORDER_STATE.CANCEL_SUCCESS].includes(
      orderInfo?.orderState,
    );
    const newOrderData = { ...orderInfo, orderMobile: orderInfo?.mobile, isOverYear, isSubscriber };
    set({ userOrderInfo: newOrderData });
    return newOrderData;
  },
}));
